import { createAction } from "@reduxjs/toolkit";
import {
  IQualitaExt,
  IQualitaUpdatePublishedStore,
} from "../../../../interfaces/lotto/attributes/models";
import {
  EMPTY,
  GET,
  IQualitaExtListPayload,
  IQualitaListPayload,
  LIST,
  LIST_EXT,
  UPDATE_PUBLISHED,
} from "./types";

export const listAction = createAction<IQualitaListPayload>(LIST);

export const listExtAction = createAction<IQualitaExtListPayload>(LIST_EXT);

export const getAction = createAction<IQualitaExt>(GET);

export const updatePubishedAction =
  createAction<IQualitaUpdatePublishedStore>(UPDATE_PUBLISHED);

export const emptyAction = createAction(EMPTY);
